"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Undoverline = exports.UndoverlineJsonKeys = exports.LineJsonKeys = exports.PointJsonKeys = void 0;
const undoverline_tables_1 = require("./undoverline-tables");
exports.PointJsonKeys = ["x", "y"];
exports.LineJsonKeys = ["start", "end"];
exports.UndoverlineJsonKeys = ["line", "code"];
(() => {
    const testPointJsonKeys = exports.PointJsonKeys;
    const testLineJsonKeys = exports.LineJsonKeys;
    const testUndoverlineJsonKeys = exports.UndoverlineJsonKeys;
    console.log(testPointJsonKeys, testLineJsonKeys, testUndoverlineJsonKeys);
});
class Undoverline {
    constructor(lineType, line, code) {
        this.lineType = lineType;
        this.line = line;
        this.code = code;
        this.faceWithUndoverlineCodes = lineType === "underline" ?
            undoverline_tables_1.decodeUnderlineTable[code] :
            undoverline_tables_1.decodeOverlineTable[code];
        this.letter =
            this.faceWithUndoverlineCodes == null ? undefined : this.faceWithUndoverlineCodes.letter;
        this.digit =
            this.faceWithUndoverlineCodes == null ? undefined : this.faceWithUndoverlineCodes.digit;
    }
}
exports.Undoverline = Undoverline;
Undoverline.fromJsonObject = (lineType, { line, code }) => new Undoverline(lineType, line, code);
Undoverline.fromJsonUnderlineObject = (jsonObj) => jsonObj && Undoverline.fromJsonObject("underline", jsonObj);
Undoverline.fromJsonOverlineObject = (jsonObj) => jsonObj && Undoverline.fromJsonObject("overline", jsonObj);
//# sourceMappingURL=undoverline.js.map